@if (disclaimer(); as disclaimer) {
  <div
    class="flex flex--center"
    [class.pr-medium]="!isNewBrand()"
    [class.ps-medium]="isNewBrand()"
    [class.rounded-large]="isNewBrand()"
    [ngClass]="containerClasses()"
  >
    @if (disclaimer.iconUrl || disclaimer.svgIcon) {
      <div class="flex--nogrow heather-700-text text-icon-primary font-body-medium">
        @if (disclaimer.iconUrl) {
          <img [src]="disclaimer.iconUrl" [alt]="disclaimer.teaserTitle" />
        }
        @if (disclaimer.svgIcon) {
          <fcom-icon
            [name]="disclaimer.svgIcon"
            class="ps-medium-r nordic-blue-900-text text-icon-primary icon-medium"
          />
        }
      </div>
    }
    @if (disclaimer.target; as target) {
      <div class="flex-1 font-body-medium">
        <a
          class="nordic-blue-900-text text-icon-primary font-body-medium"
          [finLink]="target.url"
          [external]="target.external"
          >{{ target.teaserTitle }}</a
        >
      </div>
    } @else {
      <div
        class="disclaimer-content flex-1 font-body-medium"
        [innerHTML]="disclaimer.teaserText | finSafe: 'html'"
      ></div>
    }
  </div>
}
